import styled from 'styled-components'

const EasyToClickInlineButton = styled.button`
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: -4px;
    right: -8px;
    bottom: -4px;
    left: -8px;
    cursor: pointer;
  }

  &.ui.basic.primary.button {
    box-shadow: none !important;
    padding: 0;
  }
`

export default EasyToClickInlineButton



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/EasyToClickInlineButton.js